import { generateDialogParams } from '@/lib/generic.utils'
import { DataService } from '@api/index'
const SERVICE = new DataService('license-periods')

export default {
  getAll(context) {
    return new Promise((resolve, reject) => {
      return SERVICE.get()
        .then(response => {
          context.commit('updateAll', response.data.result)
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getSingle(context, params) {
    return new Promise((resolve, reject) => {
      return SERVICE.get(params)
        .then(response => {
          context.commit('updateSingle', response.data.result)
          if (!response.data.errors) {
            resolve(response.data.result)
          } else {
            reject(new Error('Something went wrong. Please reload the page.'))
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getCreateFormData(context) {
    return new Promise((resolve, reject) => {
      return SERVICE.getCreateFormData()
        .then(response => {
          context.commit('updateActions', response.data.result.actions)
          context.commit('updatePublishers', response.data.result.publishers)
          context.commit('updateTermLabels', response.data.result.terms)
          context.commit('updateTermStatuses', response.data.result.term_statuses)
          context.commit('updateOwners', response.data.result.owners)
          resolve()
        })
        .catch(err => reject(err))
    })
  },
  deleteConfirmation(context, params) {
    return new Promise((resolve, reject) => {
      return SERVICE.getDeleteConfirmation(params)
        .then(response => {
          context.commit(
            'updateGlobalDialogContent',
            generateDialogParams(params.dialogUid, 'deleteSingle', response.data),
            { root: true }
          )
          context.commit('updateGlobalDialogVisibility', { uid: params.dialogUid, value: true }, { root: true })
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  deleteSingle(context, params) {
    return new Promise((resolve, reject) => {
      return SERVICE.delete(params)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  create(context, params) {
    return new Promise((resolve, reject) => {
      return SERVICE.create(params)
        .then(response => {
          if (!response.data.messages.errors) {
            resolve(response.data.result)
          } else {
            reject(response)
          }
        })
        .catch(reject)
    })
  },
  update(context, params) {
    return SERVICE.updateWithPost(params)
      .then(response => response.data.result)
      .catch(err => err)
  }
}
